import { createSlice } from "@reduxjs/toolkit";
import { TRANSLATION_ID_MAPPING } from "./translation-mapping";

const languageSlice = createSlice({
  name: "language",
  initialState: {
    language: "en",
    translations: [],
    translationsMap: {},
  },
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setTranslations: (state, action) => {
      state.translations = action.payload.data;

      state.translationsMap = action.payload.data.reduce((map, item) => {
        const keyName = TRANSLATION_ID_MAPPING[item.id];
        if (keyName) {
          map[keyName] = item.description;
        } else {
          map[item.keyName] = item.description;
        }
        return map;
      }, {});
    },
  },
});

export default languageSlice;

export const languageActions = languageSlice.actions;


export function fetchLanguageTranslations(documentId) {
  return async (dispatch) => {
    try {
      const browserlanguage = window.navigator.language;
      const url = `${process.env.REACT_APP_API}/docs/languagetranslations/${documentId}/${browserlanguage}`;
      const response = await fetch(url);
      const data = await response.json();

      console.log("Translation data:", data);

      dispatch(languageActions.setTranslations(data));
      dispatch(languageActions.setLanguage(browserlanguage));
    } catch (error) {
      console.log("Error fetching translations:", error);
    }
  };
}
